var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilBoldOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4582 6.78451C17.8047 6.43801 17.9954 5.97784 17.9954 5.48834C17.9954 4.99884 17.8047 4.53867 17.4582 4.19217L16.0044 2.73834C15.6579 2.39184 15.1977 2.20117 14.7082 2.20117C14.2187 2.20117 13.7586 2.39184 13.413 2.73742L3.66699 12.4532V16.5003H7.71224L17.4582 6.78451ZM14.7082 4.03451L16.163 5.48742L14.7055 6.93942L13.2517 5.48651L14.7082 4.03451ZM5.50033 14.6669V13.214L11.9537 6.78084L13.4075 8.23467L6.95508 14.6669H5.50033ZM3.66699 18.3336H18.3337V20.1669H3.66699V18.3336Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBoldOutlined);
export default __webpack_public_path__ + "static/media/pencil_bold_outlined.be18da2b2108cf0bf710eac334a223b2.svg";
export { ForwardRef as ReactComponent };